import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TCheckedType, TProjectConfigurationGeneralItem } from 'pages/common/types';
import { TSavedProjectsComplimentaryGroup } from '../types';

type TParams = {
  mainProduct: TProjectConfigurationGeneralItem | Record<string, never>;
  complementaryProducts: TProjectConfigurationGeneralItem[];
  complimentaryGroups: TSavedProjectsComplimentaryGroup[];
  checkedProducts: TCheckedType;
};

// В Recoil до инициализации mainProduct — пустой объект {}; не добавляем его в generalItems.
const isMainProductSet = (
  mainProduct: TProjectConfigurationGeneralItem | Record<string, never>
): mainProduct is TProjectConfigurationGeneralItem => Object.keys(mainProduct).length > 0;

const getSelectedComplimentaryGeneralItems = ({
  complementaryProducts,
  complimentaryGroups,
  checkedProducts,
}: Pick<
  TParams,
  'complementaryProducts' | 'complimentaryGroups' | 'checkedProducts'
>): TProjectConfigurationGeneralItem[] => {
  if (!checkedProducts.length) {
    return [];
  }

  const result: TProjectConfigurationGeneralItem[] = [];

  complementaryProducts.forEach(product => {
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: product.code });
    if (isProductChecked && product.quantity > 0) {
      result.push(product);
    }
  });

  complimentaryGroups.forEach(group => {
    const selectedProduct = group.products.find(product => product.code === group.selectedProductId);
    if (selectedProduct) {
      const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: selectedProduct.code });
      if (isProductChecked && selectedProduct.quantity > 0) {
        result.push(selectedProduct);
      }
    }
  });

  return result;
};

export const getGeneralItemsFromCalculationState = ({
  mainProduct,
  complementaryProducts,
  complimentaryGroups,
  checkedProducts,
}: TParams): TProjectConfigurationGeneralItem[] => {
  const generalItems = isMainProductSet(mainProduct) ? [mainProduct] : [];

  return [
    ...generalItems,
    ...getSelectedComplimentaryGeneralItems({
      complementaryProducts,
      complimentaryGroups,
      checkedProducts,
    }),
  ];
};
